module.exports = __webpack_public_path__ + "static/interiorandexterior-aef2c15af43a875a05029aa66448d2e2.jpg";